import { GridList, Paper, Typography, makeStyles, MuiThemeProvider, createMuiTheme, TableCell, } from "@material-ui/core";
import { createRef, useEffect, useReducer, useState } from "react";
import CloseImage from '../../assets/ic_close.png';
import api from "../api";
import MUIDataTable from 'mui-datatables';
import filterIcon from '../../assets/ic_search@3x.png';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { format } from 'date-fns';
import DateFnsUtils from "@date-io/date-fns";

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTableHistory());
const style = {
    position: "sticky",
    zIndex: 110
};
const options = ct.customOptionsSearch()

export default function HistoryPenyerahanBPJS(props) {
    const [dataTable, setDataTable] = useState([]);
    const [open, setOpen] = useState(false);
    const [validFrom, setValidFrom] = useState(new Date());
    const [validTo, setValidTo] = useState(new Date());
    const wrapperRef = createRef()


    const columns = [{
        label: "Tanggal",
        options: {
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white', }}>
                    <Typography style={{fontSize: '12pt', textAlign: 'left', color: '#2a9c6c'}}>{columnMeta.label}</Typography>
                </TableCell>
            ),
        }
    }, "Sub Fasilitas", "No. Antrian", "ID Reservasi", "No. Rekam Medis", "Nama Pasien", "Catatan Petugas", "Kode Referral", "Status", "Alasan","Loket", "Diproses Oleh", "Waktu Proses"];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',
    };

    const handleClick = () => {
        const wrapper = wrapperRef.current;
        // console.log(wrapper.classList);
        wrapper.classList.toggle('is-nav-open')
        setOpen(!open)
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    useEffect(() => {
        props.setShowNotif(true)
        getDataTable()
    }, [])

    const getDataTable = () => {
        api.create().getAllHistoryName("BPJS Verification").then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let dataTable = response.data.data.map((item, index) => {
                        return [
                            item.queue_date,
                            item.sub_facility_name,
                            item.queue_number,
                            item.booking_id,
                            item.patient_medical_record_no === null ? "" : item.patient_medical_record_no,
                            item.patient_name === null ? "" : item.patient_name,
                            item.other_notes === null ? "" : item.other_notes,
                            item.refferal_code === null ? "" : item.refferal_code,
                            item.queue_status_name === null ? "" : item.queue_status_name,
                            item.reasons === null ? "" : item.reasons,
                            item.facility_counter_name === null ? "" : item.facility_counter_name,
                            item.processed_by === null ? "" : item.processed_by,
                            item.processed_at === null ? "" : item.processed_at,
                        ]
                    })
                    setDataTable(dataTable)
                }
            }
        })
    }

    const handleFilter = () => {
        let from = format(validFrom, 'yyyy-MM-dd')
        let to = format(validTo, 'yyyy-MM-dd')
        api.create().getAllHistoryByDateName("BPJS Verification", from, to).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let dataTable = response.data.data.map((item, index) => {
                        return [
                            item.queue_date,
                            item.sub_facility_name,
                            item.queue_number,
                            item.booking_id,
                            item.patient_medical_record_no === null ? "" : item.patient_medical_record_no,
                            item.patient_name === null ? "" : item.patient_name,
                            item.other_notes === null ? "" : item.other_notes,
                            item.refferal_code === null ? "" : item.refferal_code,
                            item.queue_status_name === null ? "" : item.queue_status_name,
                            item.reasons === null ? "" : item.reasons,
                            item.facility_counter_name === null ? "" : item.facility_counter_name,
                            item.processed_by === null ? "" : item.processed_by,
                            item.processed_at === null ? "" : item.processed_at,
                        ]
                    })
                    setDataTable(dataTable)
                }
            }
        })
    }

    return (
        <div style={{ padding: '0px 20px 20px 20px' }}>
            <div style={{ position: 'relative' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', right: 70, top: 10, zIndex: 2 }}>
                    <div onClick={() => handleClick()} style={{ height: 32, width: 40, backgroundColor: 'white', borderRadius: 20, marginRight: 10, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                        <img
                            style={{ margin: 'auto', width: 20, marginLeft: 10, marginTop: 5 }} src={filterIcon} />
                    </div>
                </div>
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dataTable}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>

            <div className={"wrapper"} ref={wrapperRef} style={{ width: 400, height: props.height, position: 'absolute', marginRight: !open ? -400 : -400, top: 0, zIndex: 1000 }}>
                <div className={"nav__body"} style={{ backgroundColor: 'white', height: '100%', width: '100%' }}>
                    <div className="" style={{ height: 64, backgroundColor: '#278863', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ color: 'white', fontSize: 18, marginLeft: 40 }}>Filter</span>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => handleClick()}
                            style={{ marginRight: 20 }}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                    <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Tanggal Mulai"
                                format="dd/MM/yyyy"
                                value={validFrom}
                                onChange={(date) => {
                                    setValidFrom(date)
                                    forceUpdate()
                                }}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                style={{ width: '100%' }}
                            />
                        </MuiPickersUtilsProvider>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Tanggal Selesai"
                                minDate={validFrom}
                                format="dd/MM/yyyy"
                                value={validTo}
                                onChange={(date) => {
                                    setValidTo(date)
                                    forceUpdate()
                                }}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                style={{ width: '100%', marginTop: 30 }}
                            />
                        </MuiPickersUtilsProvider>
                    </div>

                    <div style={{ marginTop: 60, display: 'flex', justifyContent: 'center' }}>
                        <button
                            onClick={(e) => handleFilter()}
                            style={{ outline: 'none', height: 39, width: 269, borderRadius: 20, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', backgroundColor: '#278863', borderColor: 'transparent', cursor: 'pointer' }}>
                            <Typography style={{ textAlign: 'center', color: 'white' }}>Submit</Typography>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}